<template>
  <div>
    <el-form label-width="90px" v-if="form.name !== 'SpanLayout'" label-position="top" >
      <el-form-item label="表单id" v-show="false">
        <el-input size="small" :readonly="true"  v-model="form.id"/>
      </el-form-item>
      <el-form-item label="标题" v-if="form.name !== 'Description' && form.name !== 'JoinDate'">
        <el-input size="small" clearable v-model="form.title" maxlength="50" show-word-limit/>
      </el-form-item>
      <component :is="form.name" v-model="form.props" :formName="form.name" />
      <el-form-item :label="form.name == 'JoinDate' ? '' :'其他'" class="form-other">
        <!-- {{form.name}} -->
        <!-- 单选框 多选框 可展开 -->
        <el-checkbox v-model="form.props.expanding" v-if="form.name === 'SelectInput' || form.name === 'MultipleSelect'">
          <span class="name-text">选择平铺</span>
        </el-checkbox>
        <!-- 说明文字不是必填 -->
        <el-checkbox v-model="form.props.required" v-if="form.name !== 'Description' && form.name !== 'JoinDate'">
          <span class="name-text">必填</span>
        </el-checkbox>
        <el-checkbox v-model="form.props.showDetail" v-if="form.name === 'Description'">
          <span class="name-text">不在审批页显示</span>
        </el-checkbox>
        <el-checkbox v-model="form.props.enablePrint">
          <span class="name-text">参与打印</span>
          <span class="min-text">如不勾选，打印时不显示该项</span>
        </el-checkbox>
        <!-- 金额显示大写 -->
        <el-checkbox v-model="form.props.showChinese" v-if="form.name === 'AmountInput'">
          <span class="name-text">显示大写</span>
        </el-checkbox>
      </el-form-item>
    </el-form>
    <el-empty v-else description="当前组件不支持配置"></el-empty>
  </div>

</template>

<script>
import TextInput from './config/TextInputConfig.vue'
import PhoneInput from './config/PhoneInputConfig.vue'
import NumberInput from './config/NumberInputConfig.vue'
import AmountInput from './config/AmountInputConfig.vue'
import TextareaInput from './config/TextareaInputConfig.vue'
import MultipleSelect from './config/SelectInputConfig.vue'
import SelectInput from './config/SelectInputConfig.vue'
import DateTime from './config/DateTimeConfig.vue'
import DateTimeRange from './config/DateTimeRangeConfig.vue'
import ImageUpload from './config/ImageUploadConfig.vue'
import FileUpload from './config/FileUploadConfig.vue'
import Description from './config/DescriptionConfig.vue'
import MoneyInput from './config/MoneyInputConfig.vue'
import DeptPicker from './config/OrgPickerConfig.vue'
import AreaPicker from './config/AreaPickerConfig.vue'
import UserPicker from './config/UserPickerConfig.vue'
import TableList from './config/TableListConfig.vue'
import PurchaseGoodsList from './config/PurchaseGoodsList.vue'
import JoinDate from './config/JoinDateConfig.vue'

export default {
  name: "FormComponentConfig",
  components: {
    TextInput,
    PhoneInput,
    NumberInput,
    AmountInput,
    TextareaInput,
    SelectInput,
    MultipleSelect,
    DateTime,
    DateTimeRange,
    ImageUpload,
    FileUpload,
    Description,
    MoneyInput,
    DeptPicker,
    AreaPicker,
    UserPicker,
    TableList,
    PurchaseGoodsList,
    JoinDate
  },
  props:{},
  computed:{
    form(){
      return this.$store.state.selectFormItem
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.form-other{
  /deep/{
    .el-checkbox__label{
      padding-left: 4px;
    }
    .el-form-item__content,
    .el-checkbox{
      line-height: 28px;
      display: block;
    }
  }
 .name-text{
    font-size: 14px;
    color: #2F3030;
  }
  .min-text{
    font-size: 12px;
    color: #C5C9C9;
    display: inline-block;
    padding-left: 8px;
  }
}
  
  
</style>
